import React from 'react';

import Bell from './svg/bell';
import {ReactComponent as Box} from './svg/box.svg';
import {ReactComponent as Calendar} from './svg/calendar.svg';
import {ReactComponent as CalendarEvent} from './svg/calendar-event.svg'
import {ReactComponent as Check} from './svg/check.svg';
import {ReactComponent as Clock} from './svg/clock.svg';
import {ReactComponent as Cog} from './svg/cog.svg';
import {ReactComponent as CreditCard} from './svg/credit-card.svg';
import {ReactComponent as Edit} from './svg/edit.svg';
import {ReactComponent as Euro} from './svg/euro.svg';
import {ReactComponent as Gift} from './svg/gift.svg';
import {ReactComponent as Home} from './svg/home.svg';
import {ReactComponent as MapPin} from './svg/map-pin.svg';
import {ReactComponent as Pen} from './svg/pen.svg';
import {ReactComponent as Phone} from './svg/phone.svg';
import {ReactComponent as Pin} from './svg/pin.svg';
import {ReactComponent as Recurring} from './svg/recurring.svg'
import {ReactComponent as SignOut} from './svg/sign-out.svg';
import {ReactComponent as User} from './svg/user.svg';
import {ReactComponent as Users} from './svg/users.svg';
import {ReactComponent as UserStar} from './svg/user-star.svg';

import PropTypes from 'prop-types';

const Icon = ({name, size, color, ...props}) => {
    const iconProps = {
        ...props,
        style: {
            stroke: color,
            fill: color,
            width: size,
            height: size
        }
    };

    switch(name) {
        case 'bell':
            return <Bell color={color} size={size}/>;
        case 'box':
            return <Box {...iconProps}/>;
        case 'calendar':
            return <Calendar {...iconProps}/>;
        case 'calendar-event':
            return <CalendarEvent {...iconProps}/>;
        case 'check':
            return <Check {...iconProps}/>;
        case 'clock':
            return <Clock {...iconProps}/>;
        case 'cog':
            return <Cog {...iconProps}/>;
        case 'credit-card':
            return <CreditCard {...iconProps}/>;
        case 'edit':
            return <Edit {...iconProps}/>;
        case 'euro':
            return <Euro {...iconProps}/>;
        case 'gift':
            return <Gift {...iconProps}/>;
        case 'home':
            return <Home {...iconProps}/>;
        case 'map-pin':
            return <MapPin {...iconProps}/>;
        case 'pen':
            return <Pen {...iconProps}/>;
        case 'phone':
            return <Phone {...iconProps}/>;
        case 'pin':
            return <Pin {...iconProps}/>;
        case 'recurring':
            return <Recurring {...iconProps}/>;
        case 'sign-out':
            return <SignOut {...iconProps}/>;
        case 'user':
            return <User {...iconProps}/>;
        case 'users':
            return <Users {...iconProps}/>;
        case 'user-star':
            return <UserStar {...iconProps}/>;
        default:
            return null;
    }
};

Icon.propTypes = {
    name: PropTypes.oneOf(['bell', 'box', 'calendar', 'calendar-event', 'check', 'clock', 'cog', 'credit-card', 'edit', 'euro', 'gift', 'home', 'map-pin', 'pen', 'phone', 'pin', 'recurring', 'sign-out', 'user', 'users', 'user-star'])
};

export default Icon